<template>
  <Popup :header="header" @accept="acceptAndClose()" @abort="closePopup()">
    <template v-slot:content>
      <v-row>
        <template v-for="(ueberschrift, ueberschrift_index) in ueberschriften">
          <v-col cols="12" :key="ueberschrift_index">
            <v-text-field
              v-if="ueberschrift.value != 'aktionen'"
              :label="ueberschrift.text"
              type="text"
              v-model="antwortKopie[ueberschrift.value]"
            />
          </v-col>
        </template>
      </v-row>
    </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';
import _ from 'lodash';

export default {
  name: 'FragebogenPopup',
  components: { Popup },
  props: {
    ueberschriften: {
      type: Array,
      default: () => [{}, {}],
    },
    antwort: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      header:
        Object.keys(this.antwort).length === 0
          ? 'Neue Zeile hinzufügen'
          : 'Bearbeiten',
    };
  },
  antwortKopie: {
    type: Object,
    default: () => {},
  },
  beforeMount() {
    if (this.antwortKopie == {}) {
      for (this.ueberschrift of this.ueberschriften) {
        this.antwortKopie[this.ueberschrift.value] = '';
      }
    } else {
      this.antwortKopie = _.cloneDeep(this.antwort);
      this.antwortKopie;
    }
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('close');
    },
    acceptAndClose() {
      Object.keys(this.antwortKopie).forEach((key) => {
        this.antwort[key] = this.antwortKopie[key];
      });
      this.$emit('save', this.antwort);
      this.closePopup();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
